import React, { useEffect, useState } from "react";
//import "./Features.css";
import { useNavigate } from "react-router-dom";
import { getAuth, onAuthStateChanged } from "firebase/auth";

function Features() {

    const navigate = useNavigate();
    const [isLoggedIn, setIsLoggedIn] = useState(false);

    useEffect(() => {
        const auth = getAuth();
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            setIsLoggedIn(!!user);
        });
        return () => unsubscribe();
    }, []);


    const handleCTA = () => {
        navigate(isLoggedIn ? "/home" : "/login");
    };

    const features = [
        {
            title: "🧠 AI-Powered Email Scrubber",
            description: "Upload your email list and let our smart system detect and remove invalid, duplicate, or risky emails with high accuracy."
        },
        {
            title: "🔒 Secure Firebase Authentication",
            description: "Sign up or log in effortlessly using email, password, or Google—protected by Firebase security standards."
        },
        {
            title: "💳 Pay-As-You-Go Credit System",
            description: "Only pay for the email credits you need. No subscriptions, no hidden fees, and your credits never expire."
        },
        {
            title: "⚡ Stripe Payment Integration",
            description: "Buy credits instantly and securely through Stripe, with real-time balance updates in your dashboard."
        },
        {
            title: "📁 Email List Upload & Clean Download",
            description: "Easily upload your email list (CSV) and download a cleaned version after scrubbing in seconds."
        },
        {
            title: "🇪🇺 EU-Based Secure Hosting",
            description: "All servers and user data are securely hosted in Europe, ensuring full GDPR compliance and peace of mind."
        }
    ];

    const testimonials = [
        {
            review: "⭐️⭐️⭐️⭐️⭐",
            name: "Anna P., E-commerce Manager",
            feedback:  "Finally, an email cleaner that just works! The interface is clean, and I love that I only pay for what I use. My bounce rate dropped by 35% after scrubbing my old lists.",
        },
        {
            review: " ⭐️⭐️⭐️⭐️⭐",
            name: "Lukas M., Digital Marketer",
            feedback: "Stripe integration was seamless, and the credit system is super fair. I scrubbed 10k emails in minutes and the results were spot on."
        },
        {
            review: " ⭐️⭐️⭐️⭐️⭐",
            name: "Sarah K., Freelance Copywriter",
            feedback: "Being able to log in with Google and clean my email lists on the go is a game-changer. Everything just feels fast and secure."
        },
        {
            review: " ⭐️⭐️⭐️⭐️⭐",
            name: "Tomáš R., Startup Founder",
            feedback: "I needed something GDPR-compliant with EU data hosting, and this app delivered. Very professional and reliable service."
        },
        {
            review: " ⭐️⭐️⭐️⭐️⭐",
            name: "Emily J., CRM Specialist",
            feedback: "I’ve tried several scrubbing tools, but this one gives the most transparent pricing and accurate results. The logs and dashboard are super helpful too!"
        },
    ];

    return (
        <div className="features-container">
            <h2 className="features-title">🚀 What Makes This App Awesome?</h2>

            <div className="feature-list">
                {features.map((f, idx) => (
                    <div key={idx} className="feature-box">
                        <h3>{f.title}</h3>
                        <p>{f.description}</p>
                    </div>
                ))}
            </div>
            <div className="testimonials-cta-button-container">
                <button onClick={handleCTA} className="login-submit-btn">
                    {isLoggedIn ? "GO TO DASHBOARD" : "LETS SCRUB SOME MAILS"}
                </button>
            </div>

            <h2 className="features-title" style={{ marginTop: "40px" }}>💬 What Our Users Are Saying</h2>

            <div className="testimonial-list">
                {testimonials.map((t, idx) => (
                    <div key={idx} className="testimonial-box">
                        <h3>{t.review}</h3>
                        <p>"{t.feedback}"</p>
                        <span>- {t.name}</span>
                    </div>
                ))}
            </div>

            <div style={{ textAlign: "center", marginTop: "50px" }}>
                <button onClick={handleCTA} className="login-submit-btn">
                    {isLoggedIn ? "GO TO DASHBOARD" : "LETS SCRUB SOME MAILS"}
                </button>
            </div>
        </div>
    );
}

export default Features;